import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=daf4195a&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=daf4195a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf4195a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('daf4195a')) {
      api.createRecord('daf4195a', component.options)
    } else {
      api.reload('daf4195a', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=daf4195a&scoped=true&", function () {
      api.rerender('daf4195a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2tqnYtcuPPfip/JS/comp/CookieBox.vue"
export default component.exports